import image178100EdgeSingle from './image-178-100-edge-single';
import image191100AudienceWide from './image-191-100-audience-wide';
import image11AudienceSquare from './image-1-1-audience-square';
import image11MMASquare from './image-1-1-mma-square';
import image12MMAVertical from './image-1-2-mma-vertical';
import image41MMAWide from './image-4-1-mma-wide';
import image133100MSNSmall from './image-133-100-msn-small';
import image150100MSNInArticle from './image-150-100-msn-in-article';
import image191100MMALandscape from './image-191-100-mma-landscape';
import textBing from './text-bing';
import textBingDesktop from './text-bing-desktop';
import textBingMobile from './text-bing-mobile';
import textOutlookWeb from './text-outlook-web';
import textOutlookMobile from './text-outlook-mobile';

export const perfMaxTemplates = [
  image191100AudienceWide,
  image178100EdgeSingle,
  image150100MSNInArticle,
  image11AudienceSquare,
  image133100MSNSmall,
  image41MMAWide,
  image191100MMALandscape,
  image11MMASquare,
  image12MMAVertical,
  textBing,
  textBingDesktop,
  textBingMobile,
  textOutlookMobile,
  textOutlookWeb,
];
